import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import MobileUnderCalAds from "../../Ads"
const TITLE = "تحويل الوقت - أداة تحويل الوقت بدقة";
const DESCRIPTION =
  "حوّل الوقت بين الصيغ المختلفة بسهولة. استخدم أداة تحويل الوقت لتحويل الساعات والدقائق والثواني بسرعة وبدقة.";
const KEYWORDS =
  "تحويل الوقت, محول الوقت, تحويل الساعات, تحويل الدقائق, تحويل الثواني, أدوات قياس الوقت, حاسبة تحويل الوقت";
const OG_URL = "https://do-calculate.com/calculator/ar/unit_converter/time";
const timeParameters = {
  second: "ثانية",
  millisecond: "مللي ثانية",
  microsecond: "ميكروثانية",
  nanosecond: "نانوثانية",
  picosecond: "بيكوثانية",
  minute: "دقيقة",
  hour: "ساعة",
  day: "يوم",
  week: "أسبوع",
  month: "شهر",
  year: "سنة",
};
const time = Object.keys(timeParameters);
function UnitsList() {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const renderTable = (parameters, parameterNames) => (
    <table >
      <thead>
        <tr>
          <th >من الوحدة</th>
          <th >إلى الوحدة</th>
          <th >رابط الحاسبة</th>
        </tr>
      </thead>
      <tbody>
        {parameters
          .filter((fromParams) =>
            parameterNames[fromParams].includes(searchTerm)
          )
          .map((fromParams) =>
            parameters.map((toParams) => {
              if (fromParams !== toParams) {
                const url = `/calculator/ar/unit_converter/time/${fromParams}/${toParams}/`;
                return (
                  <tr key={`${fromParams}-${toParams}`}>
                    <td>{parameterNames[fromParams]}</td>
                    <td>{parameterNames[toParams]}</td>
                    <td>
                      <a href={url}>
                        تحويل من {parameterNames[fromParams]} إلى{" "}
                        {parameterNames[toParams]}
                      </a>
                    </td>
                  </tr>
                );
              }
              return null;
            })
          )}
      </tbody>
    </table>
  );
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
         <MobileUnderCalAds />
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>الزمن</h2>
          <input
            type="text"
            placeholder="ابحث عن وحدة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
        {renderTable(time, timeParameters)}
        <br />
      </div>
    </div>
  );
}
export default UnitsList;
